import { render, staticRenderFns } from "./PageIcon.vue?vue&type=template&id=a703a134&scoped=true&functional=true&"
import script from "./PageIcon.vue?vue&type=script&lang=ts&"
export * from "./PageIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PageIcon.vue?vue&type=style&index=0&id=a703a134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a703a134",
  null
  
)

export default component.exports